import { render, staticRenderFns } from "./PlanNotesPlanPicker.vue?vue&type=template&id=52c5de4a&lang=pug"
import script from "./PlanNotesPlanPicker.vue?vue&type=script&lang=js"
export * from "./PlanNotesPlanPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports